var _excluded = ["attributes", "children", "nodeProps", "styles", "element", "classNames", "prefixClassNames", "prefix", "as", "onClick", "renderLabel"],
  _excluded2 = ["attributes", "children", "nodeProps", "styles", "element", "classNames", "prefixClassNames", "prefix", "as", "onClick", "renderLabel"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as React from 'react';
import React__default from 'react';
import { Combobox } from '@udecode/plate-combobox';
import { ELEMENT_MENTION, COMBOBOX_TRIGGER_MENTION, getMentionOnSelectItem } from '@udecode/plate-mention';
import { createStyles } from '@udecode/plate-styled-components';
import _styled, { css } from 'styled-components';
import { getHandler } from '@udecode/plate-common';
import { useSelected, useFocused } from 'slate-react';
var MentionCombobox = function MentionCombobox(_ref) {
  var items = _ref.items,
    component = _ref.component,
    onRenderItem = _ref.onRenderItem,
    _ref$pluginKey = _ref.pluginKey,
    pluginKey = _ref$pluginKey === void 0 ? ELEMENT_MENTION : _ref$pluginKey,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? pluginKey : _ref$id,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? COMBOBOX_TRIGGER_MENTION : _ref$trigger,
    insertSpaceAfterMention = _ref.insertSpaceAfterMention,
    createMentionNode = _ref.createMentionNode;
  return /*#__PURE__*/React__default.createElement(Combobox, {
    id: id,
    trigger: trigger,
    controlled: true,
    items: items,
    component: component,
    onRenderItem: onRenderItem,
    onSelectItem: getMentionOnSelectItem({
      pluginKey: id,
      insertSpaceAfterMention: insertSpaceAfterMention,
      createMentionNode: createMentionNode
    })
  });
};
var getMentionElementStyles = function getMentionElementStyles(props) {
  return createStyles(_objectSpread({
    prefixClassNames: 'MentionElement'
  }, props), {
    root: [{
      "marginTop": "0px",
      "marginBottom": "0px",
      "marginLeft": "1px",
      "marginRight": "1px",
      "verticalAlign": "baseline",
      "display": "inline-block"
    }, props.selected && props.focused && {
      "boxShadow": "0 0 0 2px #B4D5FF"
    }, css(["padding:3px 3px 2px;border-radius:4px;background-color:#eee;font-size:0.9em;"])]
  });
};
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var MentionElement = function MentionElement(props) {
  var attributes = props.attributes,
    children = props.children,
    nodeProps = props.nodeProps,
    _styles = props.styles,
    element = props.element,
    classNames = props.classNames,
    prefixClassNames = props.prefixClassNames,
    prefix = props.prefix,
    as = props.as,
    onClick = props.onClick,
    renderLabel = props.renderLabel,
    rootProps = _objectWithoutProperties(props, _excluded);
  var selected = useSelected();
  var focused = useFocused();
  var styles = getMentionElementStyles(_objectSpread(_objectSpread({}, props), {}, {
    selected: selected,
    focused: focused
  }));
  return /*#__PURE__*/React__default.createElement(_StyledSpan$1, _extends({}, attributes, {
    as: as,
    "data-slate-value": element.value,
    className: styles.root.className,
    contentEditable: false,
    onClick: getHandler(onClick, element)
  }, rootProps, nodeProps, {
    $_css: styles.root.css
  }), prefix, renderLabel ? renderLabel(element) : element.value, children);
};
var _StyledSpan$1 = _styled("span").withConfig({
  displayName: "MentionElement___StyledSpan",
  componentId: "sc-iu2gv3-0"
})(["", ""], function (p) {
  return p.$_css;
});
var getMentionInputElementStyles = function getMentionInputElementStyles(props) {
  return createStyles(_objectSpread({
    prefixClassNames: 'MentionInputElement'
  }, props), {
    root: [{
      "marginTop": "0px",
      "marginBottom": "0px",
      "marginLeft": "1px",
      "marginRight": "1px",
      "verticalAlign": "baseline",
      "display": "inline-block"
    }, props.selected && props.focused && {
      "boxShadow": "0 0 0 2px #B4D5FF"
    }, css(["padding:3px 3px 2px;border-radius:4px;background-color:#eee;font-size:0.9em;"])]
  });
};
var MentionInputElement = function MentionInputElement(props) {
  var attributes = props.attributes,
    children = props.children,
    nodeProps = props.nodeProps,
    _styles = props.styles,
    element = props.element,
    classNames = props.classNames,
    prefixClassNames = props.prefixClassNames,
    prefix = props.prefix,
    as = props.as,
    onClick = props.onClick,
    renderLabel = props.renderLabel,
    rootProps = _objectWithoutProperties(props, _excluded2);
  var selected = useSelected();
  var focused = useFocused();
  var styles = getMentionInputElementStyles(_objectSpread(_objectSpread({}, props), {}, {
    selected: selected,
    focused: focused
  }));
  return /*#__PURE__*/React.createElement(_StyledSpan, _extends({}, attributes, {
    as: as,
    "data-slate-value": element.value,
    className: styles.root.className,
    onClick: getHandler(onClick, element)
  }, rootProps, nodeProps, {
    $_css: styles.root.css
  }), children);
};
var _StyledSpan = _styled("span").withConfig({
  displayName: "MentionInputElement___StyledSpan",
  componentId: "sc-1xv1w6t-0"
})(["", ""], function (p) {
  return p.$_css;
});
export { MentionCombobox, MentionElement, MentionInputElement, getMentionElementStyles, getMentionInputElementStyles };